import { DELETE_ICON_TOP_OFFSET } from '../../../constants/user-zone-textbox-offsets';

type GetUserZoneTextPositionProps = {
  clipPathTop: number;
  clipPathLeft: number;
  clipPathWidth: number;
  topOffset: number;
  leftOffset: number;
  rightOffset: number;
};

export const getUserZoneTextPosition = ({
  clipPathTop,
  clipPathLeft,
  clipPathWidth,
  topOffset,
  leftOffset,
  rightOffset,
}: GetUserZoneTextPositionProps) => {
  return {
    top: clipPathTop + DELETE_ICON_TOP_OFFSET + topOffset,
    left: clipPathLeft + leftOffset,
    width: clipPathWidth - (leftOffset + rightOffset),
    textAlign: 'center',
  };
};
